<template>

<svg 
	 xmlns="http://www.w3.org/2000/svg"   
	 viewBox="-11.5 780.5 24 24" >
<path d="M-1.49,801.13l2.21-2.21l-0.96-0.96l0.39-0.98l0.68-0.68l1.25,1.25l3.46-3.46l-1.25-1.24l0.68-0.68l0.97-0.41l0.96,0.97
	l2.21-2.21l1.37,1.37L-0.12,802.5L-1.49,801.13z M8.85,787.33l-4.83-4.83l-2.89,2.9l-0.97,1.93l-4.83,4.83l-1.93,0.97l-2.9,2.89
	l4.83,4.83l2.9-2.89l0.96-1.94l4.83-4.83l1.93-0.96L8.85,787.33z M-2.84,786.13l-3.03,3.03l1.35,1.35l3.03-3.03L-2.84,786.13z"/>
</svg>

</template>